import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PasswordlessPage from './PasswordlessPage';

import { clearAuthNotification as clearAuthNotificationAction } from '../../actions/auth';

import {
    cancelToS as cancelToSAction,
    acceptToS as acceptToSAction,
    showToS as showToSAction,
} from '../../actions/tos';

import {
    trackPasswordlessEmailReturn as passwordlessEmailClickedAction,
    trackPasswordlessContinueClick as passwordlessContinueClickAction,
    trackPasswordlessSetPasswordClick as passwordlessSetPasswordClickAction,
    trackPasswordlessSavePasswordClicked as passwordlessSavePasswordClickedAction,
} from '../../actions/gaTracking';

import {
    passwordlessLoginAttempt as passwordlessLoginAttemptAction,
    passwordlessSetPasswordAttempt as passwordlessSetPasswordAttemptAction,
    setPasswordlessEmailStatus as setPasswordlessEmailStatusAction,
    sendPasswordlessEmail as sendPasswordlessEmailAction,
} from '../../actions/passwordless';

const _mapStateToProps = ({ social, frontend, status }) => ({
    socialSSOSettings: social.socialSSOSettings,
    passwordlessLoginStatus: status.passwordlessLoginStatus,
    isLoading: frontend.isLoading,
    passwordlessEmailStatus: status.passwordlessEmailStatus,
    signUpSecondStep: status.signUpSecondStep,
});
const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    handlePasswordlessLogin: passwordlessLoginAttemptAction,
    handlePasswordlessSetPassword: passwordlessSetPasswordAttemptAction,
    handlePasswordlessEmailClicked: passwordlessEmailClickedAction,
    handlePasswordlessContinueClicked: passwordlessContinueClickAction,
    handlepasswordlessSetPasswordClicked: passwordlessSetPasswordClickAction,
    handlePasswordlessSavePasswordClicked:
        passwordlessSavePasswordClickedAction,
    cancelToS: cancelToSAction,
    acceptToS: acceptToSAction,
    showToS: showToSAction,
    handleSendPasswordlessLink: sendPasswordlessEmailAction,
    setPasswordlessEmailStatus: setPasswordlessEmailStatusAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(PasswordlessPage),
);
